"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _ExperimentTreatmentSelectors = require("pricing-pages-unified-ui/selectors/ExperimentTreatmentSelectors");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  min-height: 76px;\n  margin-top: 12px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// min-height of the container is hard-coded for now, optimized for sizing in English.
// In productization, the heights of the container should dynamic and equal to heights of other taglines
var TaglineWrapper = _styledComponents.default.div.withConfig({
  displayName: "Mon245Tagline__TaglineWrapper",
  componentId: "r6hk59-0"
})(_templateObject());

var Mon245Tagline = function Mon245Tagline(_ref) {
  var taglineKey = _ref.taglineKey,
      mon245ShowTagline = _ref.mon245ShowTagline;
  if (!mon245ShowTagline) return null;
  return _react.default.createElement(TaglineWrapper, null, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: taglineKey
  }));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    mon245ShowTagline: (0, _ExperimentTreatmentSelectors.mon245ShowTaglineSelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(Mon245Tagline);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/product-pages/Mon245Tagline.js
// module id = 837
// module chunks = 5 6